import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, Optional, TemplateRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { MLayoutService } from './layout.service';
import { IBreadcrumb } from './layout.type';
@Component({
  selector: 'm-layout-header',
  template: `
    <div class="m-layout-header-info">
      <i nz-icon class="m-layout-header-icon" (click)="toggleSideMenu()">
        <svg
          t="1637046654001"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="1619"
          width="20"
          height="20"
        >
          <path
            d="M192 592.832h32.448a64 64 0 0 0 64-64v-33.664a64 64 0 0 0-64-64H192a64 64 0 0 0-64 64v33.664a64 64 0 0 0 64 64zM192 289.664h32.448a64 64 0 0 0 64-64V192a64 64 0 0 0-64-64H192a64 64 0 0 0-64 64v33.664a64 64 0 0 0 64 64zM192 896h32.448a64 64 0 0 0 64-64v-33.664a64 64 0 0 0-64-64H192a64 64 0 0 0-64 64V832a64 64 0 0 0 64 64zM492.864 896h32.512a64 64 0 0 0 64-64v-33.664a64 64 0 0 0-64-64h-32.512a64 64 0 0 0-64 64V832a64 64 0 0 0 64 64zM793.792 592.832h32.448a64 64 0 0 0 64-64v-33.664a64 64 0 0 0-64-64h-32.448a64 64 0 0 0-64 64v33.664a64 64 0 0 0 64 64zM492.864 592.832h32.512a64 64 0 0 0 64-64v-33.664a64 64 0 0 0-64-64h-32.512a64 64 0 0 0-64 64v33.664a64 64 0 0 0 64 64zM793.792 896h32.448a64 64 0 0 0 64-64v-33.664a64 64 0 0 0-64-64h-32.448a64 64 0 0 0-64 64V832a64 64 0 0 0 64 64zM735.552 192v33.664a64 64 0 0 0 64 64H832a64 64 0 0 0 64-64V192a64 64 0 0 0-64-64h-32.448a64 64 0 0 0-64 64zM492.864 289.664h32.512a64 64 0 0 0 64-64V192a64 64 0 0 0-64-64h-32.512a64 64 0 0 0-64 64v33.664a64 64 0 0 0 64 64z"
            p-id="1620"
          ></path>
        </svg>
      </i>
      <ng-container *ngIf="mBreadcrumbs; else headerInfoElse">
        <ng-container *nzStringTemplateOutlet="mBreadcrumbs">{{ mBreadcrumbs }}</ng-container>
      </ng-container>
      <ng-template #headerInfoElse>
        <div class="router-area">
          <ng-container *ngFor="let item of breads; index as i">
            <span class="bread-link">
              <a *ngIf="(item.link || item.path) && i !== breads.length - 1; else spanShow" [routerLink]="item.link || item.path">
                {{ item.name }}
              </a>
            </span>
            <ng-template #spanShow>
              <span class="bread-link">{{ item.name }}</span>
            </ng-template>
            <span class="icon-separate" *ngIf="i < breads.length - 1">/</span>
          </ng-container>
        </div>
      </ng-template>
    </div>
    <div class="m-layout-header-tools" *ngIf="mTools">
      <ng-container *nzStringTemplateOutlet="mTools">{{ mTools }}</ng-container>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: true,
  exportAs: 'mLayoutHeader',
  host: {
    class: 'm-layout-header'
  }
})
export class MLayoutHeaderComponent implements OnDestroy {
  @Input()
  mTools!: string | TemplateRef<void>;
  @Input()
  mBreadcrumbs!: string | TemplateRef<void>;

  breads: IBreadcrumb[] = [];
  subscription = new Subscription();
  sideMenuVisible = true;

  constructor(@Optional() public cdr: ChangeDetectorRef, private layoutService: MLayoutService) {
    this.subscription.add(
      this.layoutService.breadcrumb$.subscribe((breads: IBreadcrumb[]) => {
        this.breads = breads;
        this.cdr?.markForCheck();
      })
    );
  }

  toggleSideMenu(): void {
    this.sideMenuVisible = !this.sideMenuVisible;
    this.layoutService.toggleSideMenu(this.sideMenuVisible);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
